import React, { useEffect, useState } from "react"
import { View, StyleSheet, ScrollView, Image, BackHandler, TouchableOpacity, ActivityIndicator } from "react-native"
import { Button } from "@Components/CustomButton/Button"
import { ContainerGlogal } from "@Components/ContainerGlogal"
import reinitialisation from "@assets/icons/reinitialisation.png"
import { BreeSerifText } from "@Components/CustomText/BreeSerifText"
import { OpenSansText } from "@Components/CustomText/OpenSansText"
import { baseColors } from "@Constants/baseStyles"
import AnimatedConfirmationCodeInput from "@Components/ConfirmationInput/AnimatedConfirmationInput"
import { useRecoilState } from "recoil"
import { registerEmailAtom } from "@Recoil/Atom/userAtom"
import { passwordCodeAtom } from "@Recoil/Atom/passwordCodeAtom"
import { ShowToast } from "@Components/ToastNotification/ToastNotification"
import { message } from "@Constants/constant"
import SimpleGoBackBtn from "@Components/SimpleGoBackBtn/SimpleGoBackBtn"
import { Spacer } from "@Components/Space"
import axios from "axios"
import { ACTIVATE_ACCOUNT_BASE_URL, AXIOS_HEADERS, RESEND_ACTIVATION_CODE_BASE_URL } from "@Services/AxiosInstance"

export const ActivationCodePage = ({ route, navigation }) => {
    const [loading, setLoading] = useState(false)
    const [sending, setSending] = useState(false)
    const [code, setCode] = useRecoilState(passwordCodeAtom)
    const [email, setEmail] = useRecoilState(registerEmailAtom)
    const backToLogin = () => navigation.navigate("LoginStack")

    useEffect(() => {
        const username = route?.params?.email
        if (username) {
            setEmail(username)
        }
    }, [route])

    useEffect(() => {
        if (code.length === 6) {
            performActivation()
        }
    }, [code])

    useEffect(() => {
        const backAction = () => {
            return true
        }
        const backHandler = BackHandler.addEventListener("hardwareBackPress", backAction)
        return () => backHandler.remove()
    }, [])

    const performActivation = () => {
        setLoading(true)
        const payload = { token: code, email }
        axios
            .post(ACTIVATE_ACCOUNT_BASE_URL(), { ...payload }, AXIOS_HEADERS)
            .then((response) => {
                const status = response.data?.status
                if (status === "INVALID_ACTIVATION_TOKEN") {
                    ShowToast({ type: "error", message: "Code d'activation invalide" })
                } else {
                    setEmail(null)
                    ShowToast({ type: "success", message: "Compte activé avec succès" })
                    backToLogin()
                }
                setLoading(false)
            })
            .catch((err) => {
                console.log(err)
                setLoading(false)
                ShowToast({ type: "error", message: message.serverError })
            })
    }

    const handleResendActivationCode = () => {
        console.log(email)
        setSending(true)
        axios
            .post(RESEND_ACTIVATION_CODE_BASE_URL(), { email }, AXIOS_HEADERS)
            .then(() => {
                setSending(false)
                ShowToast({ type: "success", message: "Code d'activation envoyé" })
            })
            .catch((e) => {
                setSending(false)
                ShowToast({ type: "error", message: message.serverError })
            })
    }

    return (
        <ContainerGlogal>
            <SimpleGoBackBtn />

            <ScrollView keyboardShouldPersistTaps={"handled"} contentContainerStyle={{ paddingBottom: 50 }}>
                <Image
                    style={{ alignSelf: "center", marginTop: "12%", height: 104 }}
                    resizeMode={"contain"}
                    source={reinitialisation}
                    defaultSource={reinitialisation}
                />
                <View style={[styles.container, { marginTop: 0 }]}>
                    <BreeSerifText textAlign={"center"} fontSize={22}>
                        Vérifier votre boîte mail !
                    </BreeSerifText>
                    <OpenSansText fontSize={16} textAlign={"center"} style={{ marginTop: 20 }}>
                        Nous vous avons envoyé un email contenant un code à usage unique pour activer votre compte .
                    </OpenSansText>
                    <AnimatedConfirmationCodeInput value={code} setValue={setCode} />
                    <Spacer height={50} />
                    <Button
                        loading={loading}
                        disabled={code.length < 6 || loading}
                        text="Activer mon compte"
                        width="80%"
                        backgroundColor={baseColors.green.primary}
                        onPress={performActivation}
                        labelColor={"white"}
                    />
                    <Spacer height={50} />

                    <TouchableOpacity disabled={!email} onPress={handleResendActivationCode}>
                        {sending ? (
                            <ActivityIndicator color={baseColors.orange.primary} size={30} />
                        ) : (
                            <OpenSansText
                                style={{ textDecorationLine: "underline" }}
                                textAlign={"center"}
                                color={baseColors.orange.primary}
                                fontSize={16}
                                fontWeight={"bold"}
                            >
                                Renvoyer le code d'activation
                            </OpenSansText>
                        )}
                    </TouchableOpacity>

                    <Spacer height={30} />
                    <View>
                        <OpenSansText
                            textAlign={"center"}
                            color={baseColors.green.primary}
                            fontSize={16}
                            fontWeight={"bold"}
                        >
                            Vous n'avez pas reçu d'email ?
                        </OpenSansText>
                        <OpenSansText
                            style={{ textDecorationLine: "underline" }}
                            textAlign={"center"}
                            color={baseColors.green.primary}
                            fontSize={16}
                            fontWeight={"bold"}
                        >
                            Vérifiez vos spams ou contactez-nous !
                        </OpenSansText>
                    </View>
                </View>
            </ScrollView>
        </ContainerGlogal>
    )
}

const styles = StyleSheet.create({
    container: {
        flex: 1,
        paddingTop: 20,
        paddingHorizontal: 20,
        backgroundColor: "white",
        alignContent: "center"
    },
    text: {
        color: baseColors.black,
        textAlign: "justify",
        fontFamily: "BreeSerif",
        fontSize: 16
    }
})
